import { Base } from "../../framework/base";
import { IdTitle } from "../common/idTitle";
import { CostCenterEditItem, ICostCenterEditItem } from "./costCenterEditItem";

export interface ICostCenterEdit {
    costCenter: ICostCenterEditItem;
    customers: IdTitle[];
}

export class CostCenterEdit implements ICostCenterEdit {
    costCenter: CostCenterEditItem;
    customers: IdTitle[];

    constructor();
    constructor(obj: ICostCenterEdit);
    constructor(obj?: any) {
        this.costCenter = null;
        if (obj && obj.costCenter) {
            this.costCenter = new CostCenterEditItem(obj.costCenter);
        }

        this.customers = Base.getTypedArray(obj?.customers ?? [], IdTitle);
    }
}